module.exports = __webpack_public_path__ + "static/media/talentx-manager.a1444b07.png";